export const RETENTION_STATUSES = {
  CANCELED: {
    label: 'Canceled',
    background: '#FDE7E9',
    color: '#8C1D18',
    dot: '#E5707A',
  },
  NEW: {
    label: 'New',
    background: '#E0EAFF',
    color: '#001C57',
    dot: '#0053FF',
  },
  DUE: {
    label: 'Due',
    background: '#FFF1D6',
    color: '#5C3B00',
    dot: '#E8A317',
  },
  LAPSED: {
    label: 'Lapsed',
    background: '#FFE4D6',
    color: '#7A2E00',
    dot: '#E8590C',
  },
  ACTIVE: {
    label: 'Active',
    background: '#E3F4EA',
    color: '#0B5A2A',
    dot: '#1E8E3E',
  },
  INACTIVE: {
    label: 'Inactive',
    background: '#EBF0F2',
    color: '#40484C',
    dot: '#6B7C87',
  },
}

// Most urgent first: the backend's by_urgency attention order, then Active
// before Inactive (the backend ties those two).
export const URGENCY_ORDER = Object.keys(RETENTION_STATUSES)

export const STATUS_FILTER_OPTIONS = [
  { value: 'all', label: 'All Students', dot: '#9AA5AD' },
  { value: 'attention', label: 'Needs attention', dot: '#D32F2F' },
  ...URGENCY_ORDER.map(status => ({
    value: status,
    label: RETENTION_STATUSES[status].label,
    dot: RETENTION_STATUSES[status].dot,
  })),
]

export const SNOOZE_DAYS = 14

export const FOLLOW_UP_LIST_PATH = '/pga-coach/students/list?status=attention'
